import {observer} from "mobx-react";
import {Component} from "preact";
import {resources} from "../resources";
import {Button} from "./controls/Button";
import {Dialog, DialogAlignment, DialogContent, DialogTitle} from "./controls/Dialog";
import {Icon} from "./controls/Icon";
import style from "./HelpDialog.module.css";

type Props = {
	open: boolean;
	onClose: () => void;
	contactUrl?: string;
	contactPhone?: string;
	termsUrl?: string;
};

function ensurePhoneLink(phone: string) {
	if (phone.indexOf("tel:") !== 0) {
		return "tel:" + phone;
	}
	else {
		return phone;
	}
}

export const HelpDialog = observer(
	class HelpDialog extends Component<Props> {
		render() {
			const {open, onClose, contactUrl, contactPhone, termsUrl} = this.props;
			return (
				<Dialog open={open} onBackdropClick={onClose} alignment={DialogAlignment.CenterAutoWidth}>
					<DialogContent>
						<DialogTitle>
							{resources.strings.HelpDialogTitle}
						</DialogTitle>
						{contactPhone && (
							<HelpLink
								icon="phone"
								href={ensurePhoneLink(contactPhone)}
								text={resources.strings.ContactPhoneName}
							/>
						)}
						{contactUrl && (
							<HelpLink icon="contact_mail" href={contactUrl} text={resources.strings.ContactUrlName} />
						)}
						{termsUrl && <HelpLink icon="assignment" href={termsUrl} text={resources.strings.TermsName} />}
						<Button onClick={onClose}>
							{resources.strings.Cancel}
						</Button>
					</DialogContent>
				</Dialog>
			);
		}
	},
);

type HelpLinkProps = {
	icon: string;
	href: string;
	text: string;
};

export const HelpLink = ({icon, href, text}: HelpLinkProps) => (
	<a class={style.helpLink} href={href} target="_blank">
		<Icon>{icon}</Icon>
		<div class={style.helpLinkText}>
			{text}
		</div>
	</a>
);
